import {
  RcbPostInjectMessageEvent,
  RcbToggleChatWindowEvent
} from 'neuraum-angus'
import { useEffect, useRef } from 'react'

import { getUUIDv4 } from '@js/common/utils'
import { FlowInformation } from '@js/WTPayload'

import { CHAT_BUTTON_TEXT } from '@f-fertighaus/applications/ChatAssistant/components/components'

export const initChatWTFlow = (savedFlowId: string): FlowInformation => ({
  flow_type: 'chat-model-engagement',
  flow_id: savedFlowId || getUUIDv4(),
  flow_kickoff: [],
  flow_step: 1
})

export const FLOW_ID_STORAGE_KEY = 'chat-assistant-flow-id'

type MessageEventType = 'send' | 'receive'

export const useChatWebtracking = (vendorName: string) => {
  const savedFlowId = localStorage.getItem(FLOW_ID_STORAGE_KEY) || ''
  const wtFlow = useRef(initChatWTFlow(savedFlowId))
  const isChatAssistantInitialMessage = useRef(true)

  function trackMessageEvent(type: MessageEventType, flow: FlowInformation) {
    window._wt({
      category: 'chat-assistant',
      action: `message-${type}`,
      values: [{ type: 'content', value: 'VALUE-HIDDEN' }],
      flow_information: flow
    })
  }

  function trackChatButtonClick(wtValue: string) {
    window._wt({
      category: 'CTA-button',
      action: 'click',
      values: [
        {
          type: 'text',
          value: wtValue
        }
      ],
      location: 'chat-assistant',
      flow_information: wtFlow.current
    })
  }

  useEffect(() => {
    localStorage.setItem(FLOW_ID_STORAGE_KEY, wtFlow.current.flow_id)
  }, [wtFlow.current.flow_id])

  useEffect(() => {
    function handleUserSubmitText(event: RcbPostInjectMessageEvent) {
      if (isChatAssistantInitialMessage.current) {
        isChatAssistantInitialMessage.current = false
        return
      }

      const newFlow = {
        ...wtFlow.current,
        flow_step: wtFlow.current.flow_step + 1
      }
      wtFlow.current = newFlow
      if (event.data.message.sender === 'user') {
        trackMessageEvent('send', newFlow)
      } else {
        trackMessageEvent('receive', newFlow)
      }
    }

    window.addEventListener('rcb-post-inject-message', handleUserSubmitText)
    return () => {
      window.removeEventListener(
        'rcb-post-inject-message',
        handleUserSubmitText
      )
    }
  }, [])

  useEffect(() => {
    const handleToggleChatWindow = (event: RcbToggleChatWindowEvent) => {
      window._wt({
        category: 'chat-assistant',
        action: event.data.newState ? 'display' : 'hide',
        label: vendorName ? vendorName : 'landing-page-converter',
        values: [
          {
            type: 'version',
            value: 'engagement'
          }
        ],
        flow_information: wtFlow.current
      })
      trackChatButtonClick(event.data.newState ? CHAT_BUTTON_TEXT : '(ICON)')
    }

    window.addEventListener('rcb-toggle-chat-window', handleToggleChatWindow)
    return () => {
      window.removeEventListener(
        'rcb-toggle-chat-window',
        handleToggleChatWindow
      )
    }
  }, [vendorName])
}
